import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HttpClientModule } from '@angular/common/http';

import { NavigationListComponent } from './navigation-list/navigation-list.component';
import { SelfServiceRoutingModule } from './self-service-routing.module';
import { SelfServiceComponent } from './self-service.component';
import { PromptListComponent } from './prompt-list/prompt-list.component';
import { PromptEditComponent } from './prompt-edit/prompt-edit.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { ConfirmationDialogComponent } from './prompt-edit/confirmation-dialog/confirmation-dialog.component';
import { AuthModule } from '@uoa/auth';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    AuthModule,
    CommonModule,
    HttpClientModule,
    IonicModule,
    SelfServiceRoutingModule,
    FormsModule,
    MatDialogModule,
    NavigationListComponent,
    SelfServiceComponent,
    PromptListComponent,
    PromptEditComponent,
    AuditLogComponent,
    AudioPlayerComponent,
    ConfirmationDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SelfServiceModule {}
